/**
 * Standard tooltip shown on a disabled "Submit Order" button when the current
 * user lacks ordering permissions (managers / care coordinators). Used across
 * every ordering flow so the message is identical everywhere.
 */
export const SUBMIT_PERMISSION_TOOLTIP = 'Practitioner permissions required to submit orders'

/**
 * Standard tooltip shown on a disabled "Review Order" / "Submit Order" button
 * when the order has not been signed yet. Every ordering flow requires a
 * signature before the order can be reviewed or submitted. Wording stays
 * neutral ("proceeding") so it reads correctly on both Review and Submit.
 */
export const SIGNATURE_REQUIRED_TOOLTIP = 'Please sign the form before proceeding'

/**
 * Why an order can only be saved as a draft: it cannot be faxed anywhere yet.
 * One sentence per reason, shared by every ordering flow so Labcorp, Quest and
 * Radiology explain the same situation in the same words (PD-775).
 */
export function draftOnlyReason(reason: {
  usingCoordinatorNote: boolean
  facilityPendingApproval: boolean
}): string {
  if (reason.usingCoordinatorNote) {
    return 'No facility selected. A care coordinator will complete the order based on your note.'
  }
  if (reason.facilityPendingApproval) {
    return 'This facility is pending admin approval. Your order will be saved as a draft and can be submitted once an admin approves the facility.'
  }
  return 'This facility has no fax number on file. You can save the order as a draft. An admin can add the fax number, then you can resubmit the order.'
}
